<template>
  <div class="detail">
    <el-dialog title="物流详情"
               :visible.sync="dialogVisible"
               width="992px"
               :before-close="handleClose">
      <div class="main scroll-auto">
        <div class="item"
             v-if="dataList && dataList.length > 0">
          <div class="boxShadow"
               v-for="(item, index) in dataList"
               :key="index">
            <el-row :gutter="40">
              <el-col :span="10"
                      style="padding: 20px">
                <div class="info">
                  <div class="row">
                    <p>快递</p>
                    <span>{{ item[0].express_companys }}</span>
                  </div>
                  <div class="row">
                    <p>物流单号</p>
                    <span>{{ item[0].express_no || "-" }}</span>
                  </div>
                  <div class="row">
                    <p>订单编号</p>
                    <span>{{ orders_sn }}</span>
                  </div>
                </div>
                <div class="goods">
                  <dl>
                    <dt>商品名称</dt>
                    <dd v-for="(val, ind) in item"
                        :key="ind">{{ val.goods_name }}</dd>
                  </dl>
                  <dl class="tc">
                    <dt>数量</dt>
                    <dd v-for="(val, ind) in item"
                        :key="ind">{{ val.goods_number }}</dd>
                  </dl>
                  <dl class="tr">
                    <dt>物流费用 (元)</dt>
                    <dd v-for="(val, ind) in item"
                        :key="ind">{{ val.express_price }}</dd>
                  </dl>
                </div>
              </el-col>
              <el-col :span="14"
                      style="padding: 20px">
                <div class="timeline">
                  <div class="title">
                    <span>已发货</span>
                    <el-link type="primary"
                             @click="getNode(item[0], index)">{{ item.logistics_node.length > 0 ? "收起" : "展开物流" }}</el-link>
                  </div>
                  <div class="timeBox">
                    <ul>
                      <li v-for="(v, i) in item.logistics_node"
                          :key="i">
                        <div class="icon">
                          <img v-if="i == 0"
                               src="@/assets/img/application/编组 2.png"
                               alt="" />
                          <span v-else-if="i == item.logistics_node.length - 1"
                                class="imgfont">收</span>
                          <img v-else
                               src="@/assets/img/application/编组.png"
                               alt="" />
                        </div>
                        <p class="text">
                          {{ v.track_info }}
                          <span class="date">{{ v.record_time }}</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <el-empty description="暂无内容"
                  v-else></el-empty>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      dialogVisible: false,
      dataList: [],
      orders_sn: "",
      express_id:"",//判断当前是否属于圆通或者顺丰
    };
  },
  props: {
    logistics_token: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["getToken"]),
  },
  methods: {
    ...mapActions({
      consignmentsDetails: "commodity/consignmentsDetails",
      logisticsGetTrajectory: "commodity/logisticsGetTrajectory",
      LogisticsDetails:"commodity/LogisticsDetails"
    }),
    getNode (item, index) {
      console.log('item :>> ', item);
      if (this.dataList[index].logistics_node.length > 0) {
        this.dataList[index].logistics_node = [];
        this.$forceUpdate();
        return;
      }
      if(this.express_id!=="3" || this.express_id!=="4"){
        let params={
          orders_sn: this.orders_sn,
          waybill_no: item.express_no,
          token: this.getToken,
          id: item.id,      // 物流发货记录id
        }
        this.LogisticsDetails(params).then((res) => {
          // console.log(res);
      
          if (res.code == 1 && res.data) {
            this.dataList[index].logistics_node = res.data;
            this.$forceUpdate();
          } else {
            this.$message.error(res.msg);
          }
        });
      }else{
        let params = {
          orderNo: this.orders_sn,
          waybillNo: item.express_no,
          token: this.logistics_token,

          // 测试数据
      /*     orderNo: "O20220218205014090-2210",
          waybillNo: "YT2204387077269", */
          // token: this.logistics_token,
        };
        /**
         * 模拟数据
         * 
         *  let res = {
            code: 10000,
            msg: "执行成功",
            data: [
                {
                    record_time: "2019-07-16 13:24:47",
                    track_status: 2,
                    track_info: "顺丰速运 已收取快件",
                },
                {
                    record_time: "2019-07-16 13:43:02",
                    track_status: 2,
                    track_info: "顺丰速运 已收取快件",
                },
                {
                    record_time: "2019-07-16 15:21:35",
                    track_status: 4,
                    track_info: "快件在【沈阳沈河区鲁美营业点】已装车,准备发往 【沈阳古城集散中心】",
                },
                {
                    record_time: "2019-07-16 16:03:10",
                    track_status: 0,
                    track_info: "快件已发车",
                },
                {
                    record_time: "2019-07-16 16:48:14",
                    track_status: 6,
                    track_info: "快件到达 【沈阳古城集散中心】",
                },
                {
                    record_time: "2019-07-16 17:43:15",
                    track_status: 4,
                    track_info: "快件在【沈阳古城集散中心】已装车,准备发往 【辽阳太子河集散点】",
                },
                {
                    record_time: "2019-07-16 23:35:44",
                    track_status: 0,
                    track_info: "快件已发车",
                },
                {
                    record_time: "2019-07-17 00:43:33",
                    track_status: 6,
                    track_info: "快件到达 【辽阳太子河集散点】",
                },
                {
                    record_time: "2019-07-17 03:48:53",
                    track_status: 4,
                    track_info: "快件在【辽阳太子河集散点】已装车,准备发往 【辽阳市馨园营业点】",
                },
                {
                    record_time: "2019-07-17 06:42:45",
                    track_status: 0,
                    track_info: "快件已发车",
                },
                {
                    record_time: "2019-07-17 07:34:41",
                    track_status: 6,
                    track_info: "快件到达 【辽阳市馨园营业点】",
                },
                {
                    record_time: "2019-07-17 07:42:41",
                    track_status: 2,
                    track_info: "快件交给陈洪才，正在派送途中（联系电话：18240026638）",
                },
                {
                    record_time: "2019-07-17 09:48:47",
                    track_status: 20,
                    track_info: "已签收,感谢使用顺丰,期待再次为您服务",
                },
                {
                    record_time: "2019-07-17 09:48:52",
                    track_status: 20,
                    track_info: '在官网"运单资料&签收图",可查看签收人信息',
                },
            ],
        };
        this.dataList[index].logistics_node = res.data;
        this.$forceUpdate();
        */

        this.logisticsGetTrajectory(params).then((res) => {
          // console.log(res);
      
          if (res.code == 10000 && res.data) {
              console.log(res.data, '---------logisticsGetTrajectory')
            this.dataList[index].logistics_node = res.data;
            this.$forceUpdate();
          } else {
            this.$message.error(res.msg);
          }
        });
      }
      
    },
    handleClose () {
      this.dialogVisible = false;
    },
    getList (item) {
      this.orders_sn = item.orders_sn;
      let params = {
        orders_sn: item.orders_sn,
        token: this.getToken,
      };
      this.consignmentsDetails(params).then((res) => {
        if (res.code == 1) {
          if (res.data.goods_list) {
            this.dataList = res.data.goods_list;
            this.dataList.forEach((item) => {
              item.logistics_node = [];
              this.express_id=item[0].express_id
            });
          }



        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  height: 450px;
  overflow-x: hidden;
  .item {
    margin-bottom: 30px;
    .boxShadow {
      margin-bottom: 22px;
      .el-col-10 {
        background: #f5f5f5;
        padding-left: 40px !important;
      }
      .info {
        margin-bottom: 24px;
        border-bottom: 1px solid #e8e8e8;
        padding-bottom: 24px;
        .row {
          display: flex;
          justify-content: space-between;
          line-height: 28px;
          font-size: 14px;
          font-weight: 400;
          p {
            color: #333;
          }
          span {
            color: #666;
          }
        }
      }
      .goods {
        display: flex;
        justify-content: space-between;
        line-height: 28px;
        font-size: 14px;
        .tc {
          text-align: center;
        }
        .tr {
          text-align: right;
        }
      }
    }
    .timeline {
      .title {
        margin-bottom: 20px;
        span {
          line-height: 19px;
          margin-right: 20px;
          display: inline-block;
          vertical-align: baseline;
        }
      }
      .timeBox {
        ul {
          li {
            list-style: none;
            display: flex;
            margin-bottom: 10px;
            position: relative;
            &:last-child {
              &::before {
                display: none;
              }
            }
            &::before {
              content: "";
              width: 1px;
              height: calc(100% - 40px);
              background: #bcbcbc;
              position: absolute;
              left: 15px;
              bottom: 0;
            }
            .icon {
              width: 30px;
              height: 30px;
              margin-right: 12px;
              .imgfont {
                display: block;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                border: 2px solid #bcbcbc;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999;
              }
            }
            .text {
              line-height: 30px;
            }
            .date {
              display: block;
              color: #999;
              line-height: 30px;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>